"use client";

import { useAuthStore } from "@/app/store/use-auth-store";
import { usePlatformStore } from "@/entities/platform";
import { useLoginUser } from "@/features/auth/login/api/query";
import React, { useEffect, useRef } from "react";

type Props = {
  children: React.ReactNode;
};

const AutoAuthProvider: React.FC<Props> = ({ children }) => {
  const { params, isInitialized } = usePlatformStore();
  const { user, setUser } = useAuthStore();

  const startedRef = useRef(false);

  const email = params.client_email || "";
  const phone = params.client_phone || "";

  const payload = {
    email,
    phone: phone,
    name: "Client",
  };

  const { mutate: login } = useLoginUser({
    onSuccess: (data) => setUser(data),
  });

  useEffect(() => {
    if (!isInitialized) return;
    if (user) return;
    if (startedRef.current) return;

    if (!payload) return;

    startedRef.current = true;
    login(payload);
  }, [isInitialized, user, login]);

  return <>{children}</>;
};

export default AutoAuthProvider;
